import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldSchema, DropdownFieldOption } from '@lsq-frontend/remote-services/ar-app';
import { AbstractField } from '../dr-abstract-field/dr-abstract-field';

@Component({
    selector: 'dr-dropdown-field',
    styleUrls: ['./dr-dropdown-field.component.scss'],
    templateUrl: './dr-dropdown-field.component.html'
})
export class DropdownField extends AbstractField implements OnInit {
    @Input() fieldSchema: FieldSchema;
    @Input() field: { fieldValue: any };
    @Input() formGroup: FormGroup;
    @Input() reviewMode = false;

    public fieldOption: DropdownFieldOption;

    public ngOnInit(): void {
        this.fieldOption = this.fieldSchema.fieldOption;
    }
}
